import { isOnPipeApiConfigured } from "../../../config/onPipeConfigurator/appConfig";
import { onPipeConfiguratorApi } from "../../../services/onPipeConfiguratorApi";
import { mockConfigurationService } from "../mock/mockConfigurationService";
import type { ConfigurationService } from "../models/types";

/** Uses the real API when a base URL is configured (explicit or derived from Coil env); otherwise mock. */
export const configurationService: ConfigurationService = isOnPipeApiConfigured()
  ? onPipeConfiguratorApi
  : mockConfigurationService;
